module["exports"] = [
  "se",
  "nu",
  "info",
  "com",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/internet/domain_suffix.js
// module id = 1565
// module chunks = 1